// extracted by mini-css-extract-plugin
module.exports = {"uc":"styles_uc__2tv0l","uc__form":"styles_uc__form__16V45","uc__code":"styles_uc__code__27v38","uc__title":"styles_uc__title__3ejmR","uc__text":"styles_uc__text__3Z1Tx"};